import { useState, useEffect } from "react";
import { onAuthStateChanged, signInWithPopup, signOut, type User } from "firebase/auth";
import { auth, googleProvider } from "../lib/firebase";

type AuthState =
  | { status: "loading" }
  | { status: "unauthenticated" }
  | { status: "authenticated"; user: User }
  | { status: "unauthorized"; user: User };

export function useAuth() {
  const [state, setState] = useState<AuthState>({ status: "loading" });

  useEffect(() => {
    return onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setState({ status: "unauthenticated" });
        return;
      }
      // Check whitelist via a lightweight API call
      try {
        const token = await user.getIdToken();
        const res = await fetch("/api/whitelist", {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.ok) {
          setState({ status: "authenticated", user });
        } else {
          setState({ status: "unauthorized", user });
        }
      } catch {
        setState({ status: "unauthorized", user });
      }
    });
  }, []);

  const signIn = async () => {
    await signInWithPopup(auth, googleProvider);
  };

  const logOut = async () => {
    await signOut(auth);
  };

  return { state, signIn, logOut };
}
